import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, withModifiers as _withModifiers, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = ["src"]
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" Сохранить фото ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SetPhotomodel = _resolveComponent("SetPhotomodel")!
  const _component_SetVideoUrl = _resolveComponent("SetVideoUrl")!
  const _component_close = _resolveComponent("close")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_success_filled = _resolveComponent("success-filled")!
  const _component_draggable = _resolveComponent("draggable")!
  const _component_plus = _resolveComponent("plus")!
  const _component_el_upload = _resolveComponent("el-upload")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_MoveMasterProductPhotozoneTransferWrap = _resolveComponent("MoveMasterProductPhotozoneTransferWrap")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", null, [
      _createVNode(_component_SetPhotomodel),
      _createVNode(_component_SetVideoUrl),
      _createVNode(_component_el_upload, {
        ref: "uploader",
        "on-change": _ctx.onChange,
        action: "#",
        accept: ".jpg",
        "show-file-list": false,
        multiple: "",
        drag: "",
        "auto-upload": false
      }, {
        default: _withCtx(() => [
          (_ctx.photos?.length)
            ? (_openBlock(), _createBlock(_component_draggable, {
                key: 0,
                modelValue: _ctx.photos,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.photos) = $event)),
                "item-key": "id",
                style: {"display":"flex","flex-wrap":"wrap","gap":"10px"}
              }, {
                item: _withCtx(({ element }) => [
                  _createElementVNode("div", {
                    style: {"width":"140px","height":"140px","border":"1px solid #e4e7ed","border-radius":"3px","position":"relative"},
                    onClick: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["stop"]))
                  }, [
                    _createVNode(_component_el_icon, {
                      color: "red",
                      style: {"position":"absolute","top":"5px","right":"5px"}
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_close, {
                          onClick: () => _ctx.removePhoto(element)
                        }, null, 8, ["onClick"])
                      ]),
                      _: 2
                    }, 1024),
                    (element.created)
                      ? (_openBlock(), _createBlock(_component_el_icon, {
                          key: 0,
                          color: "green",
                          style: {"position":"absolute","bottom":"5px","right":"5px"}
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_success_filled)
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true),
                    (element.url)
                      ? (_openBlock(), _createElementBlock("img", {
                          key: 1,
                          style: {"width":"100%","height":"100%","object-fit":"contain"},
                          src: element.url
                        }, null, 8, _hoisted_1))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _: 1
              }, 8, ["modelValue"]))
            : (_openBlock(), _createBlock(_component_el_icon, {
                key: 1,
                class: "avatar-uploader-icon"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_plus)
                ]),
                _: 1
              }))
        ]),
        _: 1
      }, 8, ["on-change"]),
      _createVNode(_component_el_button, {
        loading: _ctx.isLoading,
        style: {"margin-top":"20px"},
        onClick: _ctx.save
      }, {
        default: _withCtx(() => [
          _hoisted_2
        ]),
        _: 1
      }, 8, ["loading", "onClick"])
    ]),
    (_ctx.isUserAllowedChangeTransferPhoto)
      ? (_openBlock(), _createBlock(_component_MoveMasterProductPhotozoneTransferWrap, { key: 0 }))
      : _createCommentVNode("", true)
  ], 64))
}